module.exports = vendor_02489a3986efab0b7e49;


//////////////////
// WEBPACK FOOTER
// external "vendor_02489a3986efab0b7e49"
// module id = 2
// module chunks = 0